import { ApiClientService } from './../../../../../@core/services/ApiClient.service';
import { QueryModel } from './../../../../shared/Models/queryModel';
import { BaseService } from './../../../../shared/Services/BaseService';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { authenticationService } from '../../../../shared/Services/authenticationService';
import { WfRequest } from '../models/request';
import { environment } from '../../../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RequestService extends BaseService  {
  userId: number;
  constructor(http: HttpClient, private apiClient: ApiClientService,
     auth: authenticationService) {
    super(http, auth, environment.apiUrl + 'request');
  }

  getRequestsAssignedToMe() {
    return this.getData('user');
  }

  myRequests() {
    return this.getData('UserRequests');
  }

  setDecision(item: WfRequest) {
    return this.post(item, '/decision');
  }

  getAllFollowedRequests(query: QueryModel) {
    return this.get(query, '/FollowRequests');
  }
}
